var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('articles',{attrs:{"boardId":_vm.board,"category":_vm.category,"uid":_vm.uid,"sort":_vm.sort}})}
var staticRenderFns = []

export { render, staticRenderFns }